import classNames from 'classnames';
import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { Icon, IconTypes } from '@eika/icon';

interface Props {
    isLoading: boolean;
    count?: number;
    icon: IconTypes;
    label: string;
    href: string;
    dataTrackId: string;
}

const getUnreadText = (num: number): string => {
    if (num > 0) {
        return num > 9 ? '9+' : num.toString();
    }
    return '';
};

const CounterButtonSkeleton: React.FC = () => <Skeleton className="unread skeleton" />;

const CounterButton: React.FC<Props> = ({ isLoading, count = 0, icon, label, href, dataTrackId }) => {
    return (
        <a
            href={href}
            className={classNames('message-link', 'square-button', {
                'has-unread': count && count > 0,
            })}
            data-track-id={dataTrackId}
            data-track-linkname={label}
        >
            <span className="message-link__text-content">
                <span className="message-link__icon-wrapper">
                    <Icon type={icon} />
                    {isLoading ? (
                        <CounterButtonSkeleton />
                    ) : (
                        <span className="unread" title={count > 0 ? 'nye brev' : undefined}>
                            {getUnreadText(count)}
                        </span>
                    )}
                </span>
                <span>{label}</span>
            </span>
        </a>
    );
};

export default CounterButton;
